<template>
    <b-card no-body>
        <b-card-header class="border-0">
            <h3 class="mb-0"> {{ $t('ingresos') }}</h3>
        </b-card-header>
        <b-row class="ml-3 justify-content-start align-items-start">
            <b-col v-if="this.filter.grupoEstado == 2" md="3">
                <b-form-group :label="$t('estado_pago')">
                    <el-select class="custom-input" v-model="filter.estadoPago" filterable clearable
                        :placeholder="$t('seleccione_opcion')" style="width: 100%;">
                        <el-option v-for="item in pagosOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="3">
                <b-form-group label="Material Recibido" label-for="materiales">
                    <template v-slot:label>
                        {{ $t('material_recibido') }}
                    </template>
                    <el-select multiple class="custom-input" v-model="filter.materiales" filterable
                        :placeholder="$t('materiales')" style="width: 100%;">
                        <el-option v-for="item in materialOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label-for="folio">
                    <template v-slot:label>
                        {{ $t('folio') }}
                    </template>
                    <b-form-input v-model="filter.numeroFolio" type="number" :placeholder="$t('folio')"
                        @input="onPlantaChange"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label-for="planta">
                    <template v-slot:label>
                        {{ $t('planta') }}
                    </template>
                    <el-select class="custom-input" v-model="filter.planta" filterable clearable
                        @change="onPlantaChange" :placeholder="($t('seleccione') + ' ' + $t('plantas'))"
                        style="width: 100%;">
                        <el-option v-for="item in plantaOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group>
                    <template v-slot:label>
                        {{ $t('pasillo') }} <!--{{ $t('origen') }} o {{ $t('destino') }} -->
                    </template>
                    <el-select multiple class="custom-input" :disabled="!isPlantaSelected" v-model="filter.pasillos"
                        filterable :placeholder="($t('seleccione') + ' ' + $t('pasillos'))" style="width: 100%;">
                        <el-option v-for="item in pasilloOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label-for="guia">
                    <template v-slot:label>
                        {{ $t('guia_traslado') }}
                    </template>
                    <b-form-input v-model="filter.guiaTraslado" type="text" :placeholder="$t('guia_traslado')"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label-for="ingreso">
                    <template v-slot:label>
                        {{ 'N° '+ $t('ingreso') }}
                    </template>
                    <b-form-input v-model="filter.ingreso" type="number" :placeholder="'N° '+ $t('ingreso')"></b-form-input>
                </b-form-group>
            </b-col>


            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label="Empresa" label-for="empresaID">
                    <template v-slot:label>
                        {{ $t('empresa') }}
                    </template>
                    <el-select class="custom-input" v-model="filter.empresa" filterable clearable
                        :placeholder="$t('empresa')" style="width: 100%;">
                        <el-option v-for="item in empresaOptions" :key="item.value" :label="item.text"
                            :value="item.value" />
                    </el-select>
                </b-form-group>
            </b-col>

            <b-col md="2">
                <b-form-group label-for="fechaInicio">
                    <template v-slot:label>
                        {{ $t('fecha_inicio') }}
                    </template>
                    <b-form-input v-model="filter.fechaInicio" type="date" placeholder="dd-mm-aaaa"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col md="2">
                <b-form-group label-for="fechaFin">
                    <template v-slot:label>
                        {{ $t('fecha_fin') }}
                    </template>
                    <b-form-input v-model="filter.fechaFin" type="date" placeholder="dd-mm-aaaa"></b-form-input>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="2">
                <b-form-group label-for="filtro actas">
                    <template v-slot:label>
                        {{ $t('filtrar_por_actas') }}
                    </template>
                    <div>
                        <b-form-checkbox v-model="filter.hasActa" :value="true" :unchecked-value="null">
                            {{ $t('con_actas') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
            </b-col>

            <b-col v-if="rol === 'admin'" md="3">
                <b-form-group label-for="orden" class="mb-0 d-flex">
                    <template v-slot:label>
                        {{ $t('ordenar_por') }}:
                    </template>
                    <div class="">
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="true" :unchecked-value="null" class="chek">
                            {{ $t('Recientes') }}
                        </b-form-checkbox>
                        <b-form-checkbox v-model="filter.OrderNuevos" :value="false" :unchecked-value="null" class="chek">
                            {{ $t('Antiguos') }}
                        </b-form-checkbox>
                    </div>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="ml-3 justify-content-center align-items-center">
            <b-col v-if="rol === 'admin' && !exportMode" md="auto" class="text-center">
                <b-form-group class="mt-0 mb-0" >
                    <b-button type="submit" @click="getAllFiltered()" variant="primary" :disabled="exportMode"
                        class="mt-0 mb-0;">
                        {{ $t('buscar') }}
                    </b-button>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row class="ml-3 justify-content-end">

            <b-col md="auto" class="text-center">
                <b-form-group>
                    <b-button type="submit" @click="exportIngresos()">
                        {{ $t('exportar') }}
                    </b-button>
                </b-form-group>
            </b-col>

            <b-col v-if="($route.params.grupo == 2 || $route.params.grupo == 3)" md="auto" class="text-center">
                <b-form-group>
                    <b-button type="submit" @click="facturaMode = !facturaMode"
                        :style="{ backgroundColor: facturaMode ? 'red' : 'orange', color: 'white' }">
                        {{ !facturaMode ? $t('factura') : $t('cancelar') }}
                    </b-button>

                </b-form-group>
            </b-col>
        </b-row>


        <b-row v-if="facturaMode" class="ml-3 justify-content-center align-items-center">
            <b-col md="auto" v-if="($route.params.grupo == 2 || $route.params.grupo == 3) && rol == 'admin'">
                <b-form-group>
                    <b-button v-if="!desvincularMode" v-b-modal.modal-factura :disabled="ingresosSelected.length == 0"
                        variant="warning">
                        {{ $t('adjuntar_factura') }}
                    </b-button>
                    <b-button :disabled="ingresosSelected.length == 0" v-if="desvincularMode"
                        @click="desvincularFactura" variant="info">
                        {{ $t('guardar') }}
                    </b-button>
                    <b-button @click="checkIngresosValidos" :variant="!desvincularMode ? 'info' : 'danger'">
                        {{ !desvincularMode ? $t('desvincular_factura') : $t('cancelar') }}
                    </b-button>

                    <b-button v-if="!desvincularMode" type="submit" @click="cambiarModo" variant="danger">
                        {{ $t('cancelar') }}
                    </b-button>
                    <b-modal id="modal-factura" size="xl" scrollable title="Adjuntar Factura" @ok="adjuntarFactura"
                        no-close-on-backdrop :ok-title="$t('adjuntar')">
                        <b-row>
                            <b-col cols="4">
                                <b-form-group label-for="file-input"><template v-slot:label>
                                        {{ $t('documento') }}
                                    </template>
                                    <b-form-file id="file-input" required v-model="factura.file"
                                        :browse-text="$t('adjuntar')" :state="factura.file ? true : null"
                                        accept=".jpg, .jpeg, .png, .pdf, .doc, .docx, .bmp"
                                        placeholder="Selecciona un archivo...">
                                    </b-form-file>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3">
                                <b-form-group label="Número de la Factura" label-for="numero-input">
                                    <template v-slot:label>
                                        {{ $t('numero_factura') }}
                                    </template>
                                    <b-form-input id="numero-input" type="text" v-model="factura.numero"
                                        :state="factura.numero ? true : null" placeholder="Número de la factura">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>

                            <b-col cols="3">
                                <b-form-group label="Fecha" label-for="fecha">
                                    <template v-slot:label>
                                        {{ $t('fecha') }}
                                    </template>
                                    <b-form-input id="fecha" type="date" v-model="factura.fecha"
                                        required></b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <el-table :data="ingresosFactura" stripe style="width: 100%">
                            <el-table-column prop="guiaTraslado" label="Guía de Traslado"></el-table-column>
                            <el-table-column prop="material" label="Material"></el-table-column>
                            <el-table-column prop="chofer" label="Chofer"></el-table-column>

                            <el-table-column>
                                <template v-slot="{ row }">
                                    <b-button @click="deleteFromIngresosSelected(row.id)" variant="danger" size="sm"
                                        class="ml-2">x</b-button>
                                </template>
                            </el-table-column>
                        </el-table>
                    </b-modal>
                </b-form-group>
            </b-col>
        </b-row>

        <el-table class="table-responsive table mt-4" :data="filterTableData" >
            <el-table-column
                v-if="($route.params.grupo == 2 || $route.params.grupo == 3) && rol === 'admin' && !exportMode && facturaMode"
                label="Seleccionar" width="130">
                <template v-slot:header>
                    <input type="checkbox" @change="toggleSelectAll" :checked="isAllSelected" /> Todos
                </template>
                <template v-slot="{ row }">
                    <input type="checkbox" :value="row.id" @change="selectionChange(row.id, $event)"
                        :disabled="desvincularMode && (row.numeroFactura == null || row.urlFactura == null)"
                        :checked="isRowSelected(row.id)" />
                </template>
            </el-table-column>

            <el-table-column v-if="($route.params.grupo == 2 || $route.params.grupo == 3) && !exportMode"
                label="Seleccionar" width="130">
                <template v-slot:header>
                    <span class="status">Factura</span>
                </template>
                <template  v-slot="{ row }">
                    <FileViewer v-if="row.numeroFactura !=null" :id="row.id" :url="row.urlFactura" :mode="'min'" :filename="row.numeroFactura" />      
                    <span v-else class="status">Sin Factura</span>
                </template>            
            </el-table-column>

            <el-table-column :label="'#' + $t('ingreso')" prop="budget" min-width="150px">
                <template v-slot="{ row }">
                    <router-link :to="{ name: 'detalle', params: { id: row.id } }">
                        <span class="status">{{ row.id }}</span>
                    </router-link>
                </template>
            </el-table-column>

            <el-table-column :label="$t('g_traslado')" prop="budget" min-width="150px">
                <template v-slot="{ row }">
                    <span class="status">{{ row.guiaTraslado }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('patente')" min-width="120px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.patente }}</span>
                </template>
            </el-table-column>

            <el-table-column v-if="rol === 'admin'" :label="$t('empresa')" min-width="200px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.empresa }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('material')" min-width="250px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.material }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('fecha')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.fecha }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('peso')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.pesoTotal }} {{ row.uom }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('precio')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.precio > 0 ? Number(row.precio).toLocaleString('es-ES') : 0 }} {{
                        row.moneda
                    }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('estado_pago')" min-width="170px" prop="status">
                <template v-slot="{ row }">
                    <span class="status">{{ row.estadoPago }}</span>
                </template>
            </el-table-column>

            <el-table-column :label="$t('accion')" min-width="170px" prop="action">
                <template v-slot="{ row }">
                    <b-row>
                        <b-col>
                            <router-link :to="{ name: 'documentos', params: { id: row.id } }">
                                <a variant="primary" title="Ver Documentos" class="btn-create-new">
                                    <i class="far fa-file-image"></i>
                                </a>
                            </router-link>
                        </b-col>
                        <b-col>
                            <a @click="deleteRow(row.id)" title="Eliminar" variant="primary" class="btn-create-new">
                                <i class="fas fa-trash" style="color: red; cursor: pointer;"></i>
                            </a>
                        </b-col>
                    </b-row>
                </template>
            </el-table-column>

        </el-table>
        <b-card-footer class="py-4 d-flex justify-content-end">
            <pagination v-if="total > 0" v-model="filter.page" :per-page="filter.pageSize" :total="total" @update:modelValue="changePage"
                @update:perPage="changePageSize" />
        </b-card-footer>

    </b-card>
</template>
<script>
import miscService from '@/api/miscService';
import ingresoService from '@/api/ingresoService';
import { Table, TableColumn, Select, Option } from 'element-ui'
import utilsService from '@/api/utilsService';
import FileViewer from '@/components/FileViewer';
import Pagination from '@/components/Pagination.vue';

export default {
    name: 'ingresos-table',
    components: {
        FileViewer,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Select.name]: Select,
        [Option.name]: Option,
        Pagination
    },
    data() {
        return {
            tableData: [],
            facturaMode: false,
            exportMode: false,
            search: '',
            total: 0,
            pagosOptions: [],
            filter: {
                estadoPago: null,
                grupoEstado: 0,
                materiales: [],
                pasillos: [],
                planta: null,
                page: 1,
                pageSize: 10,
                hasActa: null,
                numeroFolio: null,
                fechaInicio: null,
                fechaFin: null,
                OrderNuevos: true,
                empresa: null,
                guiaTraslado: null,
                ingreso: null
            },
            ingresosSelected: [],
            materialOptions: [],
            pasilloOptions: [],
            plantaOptions: [],
            ingresosFactura: [],
            empresaOptions: [],
            factura: {
                file: null,
                fecha: null,
                numero: ''
            },
            desvincularMode: false,
            isPlantaSelected: false,
            fechaFin: null,
            fechaInicio: null
        };
    },
    watch: {
        exportMode(newValue) {
            if (!newValue) {
                this.fechaInicio = null;
                this.fechaFin = null;
            }
        },
    },
    computed: {
        rol() {
            return utilsService.getRol();
        },
        filterTableData() {
            const searchTerm = this.search.toLowerCase();
            if (searchTerm == '') return this.tableData;
            return this.tableData.filter(item => item.material != null && (
                item.material.toLowerCase().includes(searchTerm) || item.empresa.toLowerCase().includes(searchTerm))
            );
        },
        isAllSelected() {
            return this.filterTableData.length > 0 && this.filterTableData.every(row => this.ingresosSelected.includes(row.id));
        }
    },
    async beforeMount() {
        try {
            const grupo = this.$route.params.grupo;
            const folio = this.$route.params.folio;
            this.filter.grupoEstado = grupo;
            this.filter.estadoPago = parseInt(this.$route.params.estado) || null;            
            this.filter.numeroFolio = this.$route.query.folio;
            this.materialOptions = await miscService.getMaterialesOptions();
            this.plantaOptions = await miscService.getPlantasByOptions();
            this.empresaOptions = await miscService.getEmpresasOptions();
            if (this.filter.grupoEstado == 2 || !this.filter.grupoEstado)
                this.pagosOptions = await miscService.getEstadoPagosOptions();
            await this.loadData();
        } catch (error) {
            console.error('Error fetching ingresos:', error);
        }
    },
    methods: {
        async loadData() {

            const response = await ingresoService.getAllFiltered(this.filter);
            this.tableData = response.data
            this.total = response.totalItem;
        },
        async changePage(page) {
            this.filter.page = page;
            await this.loadData();
        },
        async changePageSize(size) {
            this.filter.pageSize = size;
            this.filter.page = 1;
            await this.loadData();
        },
        async getAllFiltered() {
            if (this.exportMode) return;
            try {
                this.filter.page = 1;
                await this.loadData();
            } catch (error) {
                console.error("Error fetching data: ", error);
            }
        },
        selectionChange(rowId, event) {
            if (event.target.checked) {
                this.ingresosSelected.push(rowId);
                const ingreso = this.tableData.find(x => rowId == x.id);
                if (ingreso)
                    this.ingresosFactura.push(ingreso);
            } else {
                this.deleteFromIngresosSelected(rowId);
            }
        },
        isRowSelected(rowId) {
            return this.ingresosSelected.includes(rowId);
        },
        toggleSelectAll(event) {
            if (event.target.checked) {
                if (this.desvincularMode)
                    this.ingresosSelected = this.filterTableData.filter(row => row.urlFactura != null).map(row => row.id);
                else
                    this.ingresosSelected = this.filterTableData.map(row => row.id);
                this.ingresosFactura = this.tableData;

            } else {
                this.ingresosSelected = [];
                this.ingresosFactura = [];
            }
        },
        isMaterialValid() {
            let materiales = [...new Set(this.ingresosFactura.map(item => item.materialID))];
            return materiales.length > 7 || materiales.length <= 0;
        },
        deleteFromIngresosSelected(rowId) {
            this.ingresosSelected = this.ingresosSelected.filter(id => id !== rowId);
            this.ingresosFactura = this.ingresosFactura.filter(item => item.id !== rowId)
        },
        checkIngresosValidos() {

            this.desvincularMode = !this.desvincularMode;
            if (this.desvincularMode && this.ingresosSelected.length > 0)
                this.ingresosSelected = this.filterTableData.filter(row => row.urlFactura != null).map(row => row.id);
            else {
                this.ingresosSelected = [];
                this.ingresosFactura = [];
            }
        },
        deleteRow(id) {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirma_eliminar'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_eliminar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">Eliminando...</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await ingresoService.deleteBy(id);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error'),
                        });
                        return;
                    }
                    await this.getAllFiltered();

                    Swal.fire({
                        text: this.$t('eliminado_correctamente'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });

        },
        desvincularFactura() {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: 'Confirma si deseas desvincular la factura de los ingresos seleccionados.',
                icon: 'warning',
                showCancelButton: true,
                cconfirmButtonText: this.$t('si_adjuntar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await ingresoService.delFactura(this.ingresosSelected);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.ingresosSelected = [];
                    this.ingresosFactura = [];
                    this.factura.file = null;
                    this.factura.fecha = null;
                    this.factura.numero = '';
                    this.desvincularMode = false;
                    await this.getAllFiltered();
                    this.$bvModal.hide('modal-factura');

                    Swal.fire({
                        title: this.$t('cambios_guardados'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });
        },
        adjuntarFactura(event) {
            event.preventDefault();
            if (!this.factura || this.factura.file == null || this.factura.fecha == null || this.numero == '') {
                this.$toast.error('Por favor, completa los campos requeridos..', {
                    position: 'top-center',
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnHover: true
                });
                return;
            }

            if (this.isMaterialValid()) {
                this.$toast.error('Debes seleccionar por lo menos 1 material y máximo 7 distintos.', {
                    position: 'top-center',
                    timeout: 2000,
                    closeOnClick: true,
                    pauseOnHover: true
                });
                return;
            }

            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('confirmar_factura'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si_adjuntar'),
                cancelButtonText: this.$t('cancelar')
            }).then(async (result) => {
                if (result.isConfirmed) {

                    Swal.fire({
                        html: `<div style="display: flex; align-items: center; justify-content: center;"> 
                      <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                        <div>
                            <h3 style="color: #006393;">${this.$t('guardando')}</h3>
                        </div>
                    </div>`,
                        showConfirmButton: false,
                        allowOutsideClick: false
                    });

                    const response = await ingresoService.addFactura(this.ingresosSelected, this.factura);
                    if (!response) {
                        Swal.fire({
                            icon: "error",
                            title: "Oops...",
                            text: this.$t('error')
                        });
                        return;
                    }
                    this.ingresosSelected = [];
                    this.ingresosFactura = [];
                    this.factura.file = null;
                    this.factura.fecha = null;
                    this.factura.numero = '';
                    await this.getAllFiltered();
                    this.$bvModal.hide('modal-factura');

                    Swal.fire({
                        title: this.$t('cambios_guardados'),
                        icon: "success",
                        showConfirmButton: false,
                        timer: 2000,
                        background: '#f8f9fa',
                        customClass: {
                            title: 'swal-title',
                            icon: 'swal-icon',
                        },
                    });
                }
            });
        },
        async onPlantaChange() {
            const planta = this.filter.planta;
            this.filter.pasillos = [];
            if (planta) {
                this.pasilloOptions = await miscService.getPasillosByPlantaOptions(planta);
                this.isPlantaSelected = true;
            } else {
                this.isPlantaSelected = false;
            }
        },
        async exportIngresos() {
            try {
                Swal.fire({
                    html: `
                <div style="display: flex; align-items: center; justify-content: center;"> 
                  <img src="/img/others/loading.gif" alt="Loading" style="width: 50px; height: 50px; margin-right: 15px;">
                  <div>
                    <h3 style="color: #006393;">`+ this.$t('generando_reporte') + `...</h3>
                  </div>
                </div>`,
                    showConfirmButton: false,
                    allowOutsideClick: false
                });
                await ingresoService.getIngresosExport(this.filter);
                Swal.close();

            } catch {
                Swal.fire({
                    icon: "error",
                    title: "Oops...",
                    text: this.$t("error_exportar")
                });
                return;
            }
        },
        async cambiarModo() {
            Swal.fire({
                title: this.$t('estas_seguro'),
                text: this.$t('cancelar_vinculacion'),
                icon: 'warning',
                showCancelButton: true,
                confirmButtonText: this.$t('si'),
                cancelButtonText: this.$t('no')
            }).then(async (result) => {
                if (result.isConfirmed) {
                    this.ingresosSelected = [];
                    this.ingresosFactura = [];
                    this.facturaMode = false;
                }
            });
        }
    }
}
</script>
<style scoped>
button.btn.btn-secondary {
    vertical-align: super;

}

button.btn.btn-danger {
    vertical-align: super;
    float: right;
}

</style>